import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AddressEdit from '../components/addressEdit';
import AddressAdd from '../components/addressAdd';
import ContactEdit from '../components/contactEdit';
import ContinueBooking from '../components/continueBooking';
import Controls from '../../util/controls';

import * as AddressActions from '../actions/addressActions';

import { formValueSelector } from 'redux-form';
import { browserHistory } from 'react-router';

class AddressPage extends Component {

  constructor(props) {
    super(props);

    this.state = { contactDetails: null };
  }

  getLocalities({ value }) {
    const { actions } = this.props;

    if (value && value.length > 3)
      actions.getLocalities(value);
    else
      this.clearLocalities();
  }

  clearLocalities() {
    const { actions } = this.props;

    actions.clearLocalities();
  }

  onAddressUpdate(values) {
    let { jobId } = this.props.routeParams;
    this.props.actions.updateAddress(jobId, values);
  }

  onContactsUpdate(values) {
    let { jobId } = this.props.routeParams;

    const newValues = { ...values, jobId: jobId };

    if (this.props.jobAddressDetails.phoneNumber !== values.phoneNumber) {
      this.setState({ contactDetails: newValues });
      browserHistory.push(`/address/${jobId}/continuebooking`);
    }
    else
      this.props.actions.updateContacts(jobId, newValues);
  }

  onAddressAdd(values) {
    let { jobId } = this.props.routeParams;
    this.props.actions.addAddress(jobId, values);
  }

  onCancel() {
    browserHistory.goBack();
  }

  componentWillMount() {
    let { jobId } = this.props.routeParams;
    this.props.actions.getJobAddressDetails(jobId);
  }
  componentWillUnmount() {
    this.props.actions.clearAddressDetails();
  }

  render() {
    let { mode, jobId } = this.props.routeParams;
    return (

      this.props.address.loading ? <Controls.LoadingPanel /> :
        <div>

          {mode === 'add' && <AddressAdd
            onSubmit={this.onAddressAdd.bind(this)}
            onCancel={this.onCancel}
            getLocalities={this.getLocalities.bind(this)}
            localities={this.props.address.localities}
            clearLocalities={this.clearLocalities.bind(this)}
            {...this.props} />}
          {mode === 'edit' && (
            <AddressEdit
              onSubmit={this.onAddressUpdate.bind(this)}
              onCancel={this.onCancel}
              initialValues={this.props.jobAddressDetails}
              getLocalities={this.getLocalities.bind(this)}
              localities={this.props.address.localities}
              clearLocalities={this.clearLocalities.bind(this)}
              {...this.props} />

          )}
          {mode === 'editcontact' && (
            <ContactEdit
              onSubmit={this.onContactsUpdate.bind(this)}
              onCancel={this.onCancel}
              initialValues={this.props.jobAddressDetails}
              formValues={this.props.contactDetails}
              {...this.props} />

          )}
          {mode === 'continuebooking' && (
            <ContinueBooking
              contactDetails={this.state.contactDetails}
              updateContacts={this.props.actions.updateContacts}
              smsSent={this.props.address.smsSent} />
          )}
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    address: state.address,
    core: state.core,
    jobAddressDetails: state.address.jobAddressDetails,
    contactDetails: formValueSelector("contactdetails").bind(this, state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AddressActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);


// WEBPACK FOOTER //
// ./app/address/containers/addressPage.js